import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withAlert } from 'react-alert';
import history from '../../history';
import {
  addUploadedAttachmentsRequest,
  addUploadedAttachmentsResponse
} from '../../actions/attachments';
import {
  deleteIncidentAttachment,
  emailIncidentAssigneeRequest,
  fetchIncidentAttachmentsResponse,
  updateIncidentRequest
} from '../../actions/incidents';
import { fetchAllActiveEmployees } from '../../actions/personnel';
import { setActiveTaskRequest } from '../../actions/tasks';
import { getActiveCompany } from '../../selectors/company';
import {
  getActiveIncidentSelector,
  getIncidentAttachmentsSelector,
  getIncidentPhotoEvidenceSelector
} from '../../selectors/incidents';
import { getMessageSelector } from '../../selectors/messages';
import { getCompanyUsersSelector } from '../../selectors/personnel';
import { getActiveReportsSelector } from '../../selectors/reports';
import { getLoggedInUser } from '../../selectors/users';
import { hasAccess } from '../../utils/incidentHelper';
import Diagram from '../../components/Diagram';
import DiagramCard from '../../components/reportCards/DiagramCard';
import Modal from '../../components/Modal';
import SaveChangesModal from '../../components/Modal/saveChangesModal';
import MarkAsCompleteModal from '../../components/Modal/markAsCompleteModal';
import PhotoEvidence from '../../components/reportCards/PhotoEvidence';
import Textbox from '../../components/inputs/Textbox';
import HeaderAndFooter from '../../components/HeaderAndFooter';
import Header from '../../components/Header';
import { SaveCancelFooter } from '../../components/Footer';
import LeftNav from '../../components/LeftNav';
import ViewOnly from '../../components/ViewOnly';
import Assignee from '../../components/Assignee';
import { isComplete } from '../../utils/reportHelper';

import './index.css';

export class PhotoEvidenceContainer extends Component {
  state = {
    openUnsavedChangesModal: false,
    openMarkAsCompleteModal: false,
    openDeleteIrrelevantReportModal: false,
    openUnlockAndReopenReportModal: false,
    imageUrl: '',
    diagramCategory: { name: '', url: '' },
    hasUnsavedChanges: false,
    nonRemovedPhotos: [],
    removedPhotos: []
  };

  componentDidMount() {
    if (this.props.activeReport.report) {
      this.setState({
        activeReport: [...this.props.activeReport.report]
      });
    } else {
      this.setState({
        activeReport: [...this.props.activeReport]
      });
    }
    this.props.fetchAllActEmployees();
    const nonRemovedPhotos = this.props.photoEvidence.filter(
      photo => !photo.isRemoved && !photo.isRemovedByOwner
    );
    const removedPhotos = this.props.photoEvidence.filter(
      photo => photo.isRemoved || photo.isRemovedByOwner
    );
    this.setState({ nonRemovedPhotos, removedPhotos });
  }

  componentDidUpdate(prevProps) {
    if (this.messageUpdated(prevProps)) this.alertMessage();
    if (this.RCUpdated(prevProps)) {
      this.setState({ activeReport: this.props.activeReport });
    }
    if (this.photoEvidenceUpdated(prevProps)) {
      const nonRemovedPhotos = this.props.photoEvidence.filter(
        photo => !photo.isRemoved && !photo.isRemovedByOwner
      );
      const removedPhotos = this.props.photoEvidence.filter(
        photo => photo.isRemoved || photo.isRemovedByOwner
      );
      this.setState({ nonRemovedPhotos, removedPhotos });
    }
  }

  photoEvidenceUpdated(prevProps) {
    return (
      this.props.photoEvidence &&
      JSON.stringify(this.props.photoEvidence) !==
        JSON.stringify(prevProps.photoEvidence)
    );
  }

  RCUpdated(prevProps) {
    return (
      this.props.activeReport.length > 0 &&
      JSON.stringify(prevProps.activeReport) !==
        JSON.stringify(this.props.activeReport)
    );
  }

  alertMessage() {
    this.props.message.error
      ? this.props.alert.error(this.props.message.message)
      : this.props.alert.success(this.props.message.message);
  }

  messageUpdated(prevProps) {
    return (
      this.props.message.message &&
      prevProps.message.message !== this.props.message.message
    );
  }

  handlePhotoUpload = e => {
    const files = e.target.files;
    let data = new FormData();
    for (const file of Object.entries(files)) {
      data.append('attachments', file[1], file[1].name);
    }
    this.props.addAttachment({
      data,
      ownerId: this.props.activeIncident._id,
      ownerType: 'incident',
      isPhotoEvidence: true
    });
  };

  getBodyDiagrams = addedAttachments =>
    this.flattenedAttachmentList(addedAttachments).filter(
      attachment => attachment.original_filename.indexOf('bodydiagram') > -1
    );

  getAccidentDiagrams = addedAttachments =>
    this.flattenedAttachmentList(addedAttachments).filter(
      attachment => attachment.original_filename.indexOf('roaddiagram') > -1
    );

  getVehicleDiagrams = addedAttachments =>
    this.flattenedAttachmentList(addedAttachments).filter(
      attachment => attachment.original_filename.indexOf('vehiclediagram') > -1
    );

  flattenedAttachmentList = addedAttachments =>
    addedAttachments.reduce((acc, x) => acc.concat(x), []);

  updatePhotoEvidence = async photo => {
    const { addIncidentAttachments } = this.props;
    let photoEvidence = this.props.photoEvidence;
    photoEvidence = photoEvidence.map(currentPhoto => {
      if (currentPhoto._id === photo._id) {
        return { ...photo };
      }
      return { ...currentPhoto };
    });
    await addIncidentAttachments(photoEvidence);
    this.setState({ hasUnsavedChanges: true });
  };

  handleSubmit = async markAsComplete => {
    const {
      match,
      addUploadedAttachments,
      updateIncident,
      photoEvidence,
      addedAttachments
    } = this.props;
    const { activeReport } = this.state;
    if (match.params.isPhotoEvidence) {
      await addUploadedAttachments(photoEvidence);
    }
    const currentNumber = addedAttachments.length;

    if (
      (currentNumber > 0 || activeReport[0][1].isNotApplicable) &&
      markAsComplete === undefined
    ) {
      this.setState({ openMarkAsCompleteModal: true });
      return;
    }

    if (markAsComplete) {
      activeReport[0][4].isComplete = true;
    }

    await updateIncident({
      reportComponent: this.props.match.params.isPhotoEvidence
        ? 'Photo Evidence'
        : 'Diagrams',
      isComplete: markAsComplete ?? false
    });
  };

  reopenReportSection = async () => {
    const { activeReport } = this.state;
    activeReport[0][4].isComplete = false;

    await this.props.updateIncident({
      reportComponent: activeReport[0][0],
      isComplete: false
    });
  };

  handleNaSection = value => {
    this.setState(state => {
      const { activeReport } = state;

      activeReport[0][1] = {
        isNotApplicable: value
      };
      return { activeReport };
    });
  };

  sendEmail = () => {
    const { emailIncidentAssignee, activeIncident } = this.props;
    const { activeReport } = this.state;

    const reportTask =
      activeIncident &&
      activeIncident.incidentActivity &&
      activeIncident.incidentActivity.openTasks.filter(
        task =>
          activeReport.length > 0 &&
          task.reportComponentName === activeReport[0][0]
      );
    emailIncidentAssignee({
      messageContent: this.state.emailMessage,
      incidentId: this.props.activeIncident._id,
      userId: this.props.loggedInUser._id,
      sentMessageToId: reportTask[0].assignedTo[0]
    });

    this.setState({ openEmailAssigneeModal: false });
  };

  render() {
    const {
      loggedInUser,
      activeIncident,
      match,
      photoEvidence,
      companyUsers,
      addAttachment,
      addedAttachments,
      setActiveTask,
      deleteAttachment
    } = this.props;

    const {
      openEmailAssigneeModal,
      openUnsavedChangesModal,
      openMarkAsCompleteModal,
      openUnlockAndReopenReportModal,
      emailMessage,
      imageUrl,
      diagramCategory,
      hasUnsavedChanges,
      activeReport,
      nonRemovedPhotos,
      removedPhotos
    } = this.state;

    const leftNav = match.params.isPhotoEvidence
      ? photoEvidence.map((photo, index) => ({
          label: photo.photoName || `Photo #${index + 1}`,
          removed: photo.isRemoved || photo.isRemovedByOwner,
          id: photo._id
        }))
      : [{ label: 'Diagrams' }];

    const getBodyDiagrams = addedAttachments =>
      this.flattenedAttachmentList(addedAttachments).filter(
        attachment => attachment.original_filename.indexOf('bodydiagram') > -1
      );

    const getAccidentDiagrams = addedAttachments =>
      this.flattenedAttachmentList(addedAttachments).filter(
        attachment => attachment.original_filename.indexOf('roaddiagram') > -1
      );

    const getVehicleDiagrams = addedAttachments =>
      this.flattenedAttachmentList(addedAttachments).filter(
        attachment =>
          attachment.original_filename.indexOf('vehiclediagram') > -1
      );

    const getAircraftDiagrams = addedAttachments =>
      this.flattenedAttachmentList(addedAttachments).filter(
        attachment =>
          attachment.original_filename.indexOf('aircraftdiagram') > -1
      );

    const canRemoveEdit =
      activeIncident &&
      activeReport &&
      (loggedInUser._id === activeIncident.incidentOwner ||
        loggedInUser._id === activeReport[0][2].assignedTo ||
        hasAccess(
          loggedInUser,
          this.props.activeReport.stage,
          activeIncident
        )) &&
      !activeReport[0][4].isComplete;

    const reportTask =
      activeIncident &&
      activeIncident.incidentActivity &&
      activeIncident.incidentActivity.openTasks.filter(
        task =>
          activeReport &&
          activeReport.length > 0 &&
          task.reportComponentName === activeReport[0][0]
      );

    if (imageUrl) {
      return (
        <div className="photoEvidenceContainer">
          <div>
            {diagramCategory.name !== '' && (
              <Diagram
                imageUrl={imageUrl}
                addAttachment={values =>
                  addAttachment(values) &&
                  this.setState({ hasUnsavedChanges: true })
                }
                resetDiagrams={() =>
                  this.setState({
                    imageUrl: '',
                    diagramCategory: { name: '', url: '' },
                    diagramSubcategory: { name: '', url: '' }
                  })
                }
                loggedInUser={loggedInUser}
                category={diagramCategory.name}
              />
            )}
          </div>
        </div>
      );
    }

    const footer = (
      <SaveCancelFooter
        editing
        saveButtonClick={() => this.handleSubmit(undefined)}
        saveButtonDisabled={!hasUnsavedChanges}
        cancelButtonClick={() => history.goBack()}
      />
    );

    const left = (
      <LeftNav
        removed={activeIncident.incidentOwner === loggedInUser._id}
        items={leftNav}
        onAddEvidence={
          match.params.isPhotoEvidence &&
          canRemoveEdit &&
          this.handlePhotoUpload
        }
      />
    );

    const assignedTo = activeReport?.[0]?.[2]?.assignedTo;

    const center = (
      <ViewOnly
        report={activeReport}
        incident={activeIncident}
        onClick={() => this.setState({ openUnlockAndReopenReportModal: true })}
      />
    );
    const right =
      assignedTo && assignedTo !== 'unassigned' ? (
        <Assignee
          user={assignedTo}
          options={[
            {
              onClick: () => this.setState({ openEmailAssigneeModal: true }),
              label: 'Email Assignee'
            },
            {
              onClick: () =>
                setActiveTask({
                  ...reportTask[0],
                  isFromReport: true,
                  isForIncident: true,
                  stage: 'investigation'
                }),
              visible: activeIncident?.incidentOwner === loggedInUser._id,
              label: 'Edit Task'
            }
          ]}
        />
      ) : (
        <></>
      );
    const header = (
      <Header
        name={activeIncident?.incidentNumber}
        section={match.params.isPhotoEvidence ? 'Photo Evidence' : 'Diagrams'}
        clickBack={() =>
          hasUnsavedChanges
            ? this.setState({ openUnsavedChangesModal: true })
            : history.goBack()
        }
        needsSaved={hasUnsavedChanges}
        center={center}
        right={right}
        rightButtons={{
          visible:
            assignedTo === 'unassigned' &&
            activeIncident?.incidentOwner === loggedInUser._id,
          text: 'Assign Report as Task',
          color: 'blue',
          onClick: () =>
            setActiveTask({
              ownerId: activeIncident._id,
              ownerType: 'incident',
              reportComponentName: activeReport[0][0],
              label: `${activeIncident.incidentNumber}, ${activeReport[0][0]}`,
              currentCategory: 6,
              currentReason: 10,
              isFromReport: true,
              isForIncident: true,
              stage: 'investigation'
            })
        }}
      />
    );

    return (
      <>
        <HeaderAndFooter
          Header={header}
          Footer={footer}
          Left={left}
          showFooter={!isComplete(activeReport)}
        >
          {match.params.isPhotoEvidence && photoEvidence.length > 0 ? (
            <>
              {nonRemovedPhotos.map(photo => (
                <PhotoEvidence
                  photo={photo}
                  key={photo._id}
                  name={photo._id}
                  companyUsers={companyUsers}
                  updatePhotoEvidence={values =>
                    this.updatePhotoEvidence({ ...photo, ...values })
                  }
                  isIncidentOwner={
                    loggedInUser._id === activeIncident.incidentOwner
                  }
                  canRemoveEdit={canRemoveEdit}
                />
              ))}
              {activeIncident.incidentOwner === loggedInUser._id &&
                removedPhotos.length > 0 &&
                removedPhotos.map(photo => (
                  <PhotoEvidence
                    photo={photo}
                    key={photo._id}
                    name={photo._id}
                    companyUsers={companyUsers}
                    updatePhotoEvidence={values =>
                      this.updatePhotoEvidence({ ...photo, ...values })
                    }
                    isIncidentOwner={
                      loggedInUser._id === activeIncident.incidentOwner
                    }
                    canRemoveEdit={canRemoveEdit}
                  />
                ))}
            </>
          ) : match.params.isPhotoEvidence && photoEvidence.length === 0 ? (
            <div className="photoEvidenceContainer-noContent">
              <div>Nothing has been added yet.</div>
              <div style={{ fontSize: 18, fontWeight: 'normal' }}>
                Use Add Button to start populating this report.
              </div>
            </div>
          ) : (
            <DiagramCard
              reportSectionHeader="Diagrams"
              bodyDiagrams={getBodyDiagrams(addedAttachments)}
              accidentDiagrams={getAccidentDiagrams(addedAttachments)}
              vehicleDiagrams={getVehicleDiagrams(addedAttachments)}
              aircraftDiagrams={getAircraftDiagrams(addedAttachments)}
              deleteAttachment={deleteAttachment}
              handleDiagramSelection={value => this.setState(value)}
              name={0}
              canRemoveEdit={canRemoveEdit}
              handleNaSection={values => this.handleNaSection(values)}
              sectionNotApplicable={
                activeReport &&
                activeReport.length > 0 &&
                activeReport[0][1].isNotApplicable
              }
              showAircraft={this.props.activeCompany.showAircraft}
            />
          )}
        </HeaderAndFooter>
        <Modal
          title="Email Assignee"
          titleClassName="blueHeader"
          isOpen={openEmailAssigneeModal}
          submitButtonColor="blue"
          submitButtonText="Send Email"
          onRequestClose={() =>
            this.setState({ openEmailAssigneeModal: false })
          }
          submitActions={() => this.sendEmail()}
        >
          <div className="reportSectionContainer-emailAssigneeText">
            This email will go through the iReportSource system for record
            keeping purposes.
          </div>
          <Textbox
            fieldLabel="Email Content"
            rows={5}
            type="textarea"
            placeholder="Type email content here"
            currentValue={emailMessage}
            handleChange={e => this.setState({ emailMessage: e.target.value })}
          />
        </Modal>
        <SaveChangesModal
          isOpen={openUnsavedChangesModal}
          onRequestClose={() =>
            this.setState({ openUnsavedChangesModal: false })
          }
          submitActions={() => history.goBack()}
          savingWhat="a report"
        />
        <MarkAsCompleteModal
          isOpen={openMarkAsCompleteModal}
          onRequestClose={() =>
            this.setState({ openMarkAsCompleteModal: false })
          }
          submitActions={() => this.handleSubmit(true)}
          cancelActions={() => this.handleSubmit(false)}
        />
        <Modal
          title="Unlock and Re-Open Report"
          titleClassName="blueHeader"
          isOpen={openUnlockAndReopenReportModal}
          submitButtonColor="blue"
          submitButtonText="Re-open Report"
          onRequestClose={() =>
            this.setState({ openUnlockAndReopenReportModal: false })
          }
          submitActions={() => this.reopenReportSection()}
        >
          <div className="reportSectionContainer-emailAssigneeText">
            Unlocking this report will allow you –and users with edit
            permission– to make changes and additions to the report.{' '}
            <span style={{ color: '#c74846', fontWeight: 'bold' }}>
              This also means that the report will no longer be considered
              completed until it is filled out, saved, and marked as complete
              once more. Re-Opening this report will also remove the currently
              assigned user.
            </span>{' '}
            You can reassign this report to the same or a different user as a
            new task.
          </div>
        </Modal>
      </>
    );
  }
}

const mapStateToProps = state => ({
  loggedInUser: getLoggedInUser(state),
  message: getMessageSelector(state),
  activeReport: getActiveReportsSelector(state),
  activeIncident: getActiveIncidentSelector(state),
  photoEvidence: getIncidentPhotoEvidenceSelector(state),
  companyUsers: getCompanyUsersSelector(state),
  addedAttachments: getIncidentAttachmentsSelector(state),
  activeCompany: getActiveCompany(state)
});

const mapDispatchToProps = dispatch => ({
  emailIncidentAssignee: payload =>
    dispatch(emailIncidentAssigneeRequest(payload)),
  updateIncident: payload => dispatch(updateIncidentRequest(payload)),
  fetchAllActEmployees: () => dispatch(fetchAllActiveEmployees()),
  addAttachment: payload => dispatch(addUploadedAttachmentsRequest(payload)),
  addUploadedAttachments: payload =>
    dispatch(addUploadedAttachmentsResponse(payload)),
  addIncidentAttachments: payload =>
    dispatch(fetchIncidentAttachmentsResponse(payload)),
  setActiveTask: payload => dispatch(setActiveTaskRequest(payload)),
  deleteAttachment: payload => dispatch(deleteIncidentAttachment(payload))
});

export default withAlert(
  connect(mapStateToProps, mapDispatchToProps)(PhotoEvidenceContainer)
);
